module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Hinzufügen","confirmRemove":"Löschen bestätigen","noItemsWereFound":"Es sind keine Einträge vorhanden.","untitled":"Unbenannt","search":"Suchen","edit":"Bearbeiten","remove":"Löschen"},"en":{"add":"Add","confirmRemove":"Confirm remove","noItemsWereFound":"No items were found.","untitled":"Untitled","search":"Search","edit":"Edit","remove":"Remove"}}')
  delete Component.options._Ctor
}
